import { render } from "./DataTableLoader.vue?vue&type=template&id=9f8de534&scoped=true"
import script from "./DataTableLoader.vue?vue&type=script&lang=js"
export * from "./DataTableLoader.vue?vue&type=script&lang=js"

import "./DataTableLoader.vue?vue&type=style&index=0&id=9f8de534&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8de534"]])

export default __exports__